<template>
  <!--底部-->
  <div style="height: 40px;">
    <div class="m-footer">
      国家首批区块链信息服务商备案号：渝网信备50011219179454790019号
      <span v-show="isInDingTalk">服务备案号：渝ICP备14003483号-21X 主体备案号：渝ICP备14003483号</span>
    </div>
  </div>
</template>

<script>
import { isInDingTalk } from "../../assets/js/utils/ding-env";

  export default {
    name: "myFooter",
    props: {},
    data() {
      return {
        isInDingTalk
      }
    }
  }
</script>

<style lang="less" scoped>
  .m-footer {
    text-align: center;
    letter-spacing: 1px;
    height: 40px;
    line-height: 40px;
    width: 100%;
    font-size: 14px;
    background: #8f7b7b;
    color: #ffffff;
    font-family: Source Han Sans SC;
    z-index: 100;
  }
</style>



// WEBPACK FOOTER //
// components/myfooter/index.vue